import { style } from '@primeuix/styles/checkboxgroup';
import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-checkbox-group p-component'
};

export default BaseStyle.extend({
    name: 'checkboxgroup',
    style,
    classes
});
